import { apiUrl } from 'sow/config';

export const baseUrl = `${apiUrl}/aca`;
export const acaUrl = acaId => `${baseUrl}/${acaId}`;
